/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_UploadInputs */

const zh_common_upload = /** @type {(inputs: Common_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传`)
};

const en_common_upload = /** @type {(inputs: Common_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const es_common_upload = /** @type {(inputs: Common_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Common_UploadInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_upload = /** @type {((inputs?: Common_UploadInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_UploadInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_upload(inputs)
	if (locale === "en") return en_common_upload(inputs)
	return es_common_upload(inputs)
});